import React from "react";
import "./PrintedList.css";
import { useNavigate } from "react-router-dom";
import { FcServices } from "react-icons/fc";

import rcImg from "../assets/rcimg.jpg";
import dlImg from "../assets/dlpic.jpg";
import rcDetailImg from "../assets/rcdetail.jpg";
import mobileImg from "../assets/mobser.png";

export default function PrintedList() {

  const navigate = useNavigate();

  const lists = [
    { name: "RC PDF List", img: rcImg, path: "/dashboard/rcpdflist" },
    { name: "DL PDF List", img: dlImg, path: "/dashboard/dlpdflist" },
    { name: "RC Particulars List", img: rcDetailImg, path: "/dashboard/rcdetailslist" },
     { name: "Mobile Number List", img: mobileImg, path: "/dashboard/mobilelist" } // ✅ NEW
  ];

  return (
    <div className="plist-wrapper">

      <h2 className="plist-title">
        <FcServices className="plist-icon" /> All Printed Records
      </h2>

      <div className="plist-divider"></div>

      <div className="plist-box">

        {lists.map((item, i) => (
          <div className="plist-card" key={i}>
            <div className="plist-circle" onClick={() => navigate(item.path)}>
              <img src={item.img} alt={item.name} draggable="false" />
            </div>
            <p className="plist-name">{item.name}</p>
          </div>
        ))}

      </div>

    </div>
  );
}
